import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneCardDetails');

    return {
        DRONE_PREFIX: t('dronePrefix'),
        EM_DASH: t('emDash'),
        FAA_PREFIX: t('faaPrefix'),
        FIRMWARE: t('firmware'),
        IDS: t('ids'),
        UNIT_ACRES: t('unitAcres'),
        UNIT_DAYS: t('unitDays'),
        UNIT_FLIGHTS: t('unitFlights'),
        UNIT_HOURS_SHORT: t('unitHoursShort'),
        USAGE: t('usage'),
        WARRANTY: t('warranty'),
        WARRANTY_EXP_PREFIX: t('warrantyExpPrefix'),
        WARRANTY_EXPIRED: t('warrantyExpired')
    };
};

export default useTranslation;
